import axios from "axios";
import authHeader from "@/services/auth-header";

class PrintSetService {
  get() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/PrintSet`,
        {
            headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new PrintSetService();
